<template>
  <div class="relative flex justify-center items-center h-screen">
    <div class="inline-block animate-spin-2s ease duration-300 w-5 h-5 bg-indigo-800 mx-2"></div>
    <div class="inline-block animate-ping-2s ease duration-300 w-5 h-5 bg-indigo-800 mx-2 rounded-full"></div>
    <div class="inline-block animate-pulse ease duration-300 w-5 h-5 bg-indigo-800 mx-2 rounded-full"></div>
    <div class="inline-block animate-bounce ease duration-300 w-5 h-5 bg-indigo-800 mx-2 rounded-full"></div>
  </div>
</template>
